import React, { useState } from "react";
import { Link } from "react-router-dom";
const Home = () => {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    const [status, setStatus] = useState({ type: "", message: "" });

    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic Validation
        if (!formData.name || !formData.email || !formData.subject || !formData.message) {
            setStatus({ type: "error", message: "All fields are required!" });
            return;
        }

        try {
            const response = await fetch("https://admin.leapatinternational.com/sentmail.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.success) {
                setStatus({ type: "success", message: "Message sent successfully!" });
                setFormData({ name: "", email: "", subject: "", message: "" }); // Reset form
            } else {
                setStatus({ type: "error", message: result.message || "Something went wrong!" });
            }
        } catch (error) {
            setStatus({ type: "error", message: "Failed to send message!" });
        }
    };

    return (
        <div>
            <section class="hero">
                <div class="hero-content">
                    <p class="top_content">TIMELESS ELEGANCE IN EVERY PLANK</p>
                    <h1>Premium Flooring<br />for Every Space</h1>
                    <p>Enhance your space with high-quality flooring that blends durability,<br />elegance, and timeless charm.</p>
                    <div class="hero-buttons">

                        <a href="#" class="btn btn-light banner_btn">Support</a>
                        <Link to="/contact" className="btn btn-light banner_btn">Contact Us</Link>
                    </div>
                </div>

                <div class="quote-form">
                    <h3>Get A Quote</h3>
                    <p>Enter details for more updates.</p>
                    <form onSubmit={handleSubmit}>
                        {status.message && (
                            <div
                                className={`alert ${status.type === "success" ? "alert-success" : "alert-danger"
                                    }`}
                            >
                                {status.message}
                            </div>
                        )}
                        <label>Name</label>
                        <input type="text" id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Full Name" />
                        <label>Email address</label>
                        <input type="email" id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Your Email"
                            required />
                        <label>Subject</label>
                        <input type="text" id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Subject"
                            required />
                        <label>Message</label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required></textarea>
                        <button type="submit" class="btn">SEND</button>
                    </form>
                </div>
            </section>
            <section class="container text-center achivement_section">
                <div class="text-uppercase text-primary fw-bold small custom_css">
                    <p class="our_achivemnt">🔗 Our Achievement</p></div>
                <p class="our_achivemnt_para text-muted custom_css">Various Versions have evolved over the years, sometimes by accident</p>

                <div class="row mt-4">
                    <div class="col-12 col-md-3 col-sm-6 achivment_icon">
                        <div class="d-flex align-items-center achievement-box">
                            <img src="/assets/img/user.png" alt="Experience" class="icon" />
                            <div class="ms-3 text-start">
                                <h3 class="fw-bold">10+ years</h3>
                                <p class="text-muted mb-0">Experience</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 col-sm-6 achivment_icon">
                        <div class="d-flex align-items-center achievement-box">
                            <img src="/assets/img/rating.png" alt="Satisfaction" class="icon" />
                            <div class="ms-3 text-start">
                                <h3 class="fw-bold">100%</h3>
                                <p class="text-muted mb-0">Satisfaction</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 col-sm-6 achivment_icon">
                        <div class="d-flex align-items-center achievement-box">
                            <img src="/assets/img/users.png" alt="Happy Customer" class="icon" />
                            <div class="ms-3 text-start">
                                <h3 class="fw-bold">10,000+</h3>
                                <p class="text-muted mb-0">Happy Customer</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 col-sm-6 achivment_icon">
                        <div class="d-flex align-items-center achievement-box">
                            <img src="/assets/img/earphone.png" alt="Support" class="icon" />
                            <div class="ms-3 text-start">
                                <h3 class="fw-bold">24/7</h3>
                                <p class="text-muted mb-0">Support</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            <section class="container our_facilites">
                <div class="row justify-content-center">
                    <div class="col-md-3 col-sm-6">
                        <div class="feature-box text-left">
                            <img src="/assets/img/Group1.png" alt="Expert Engineer" class="feature-icon" />
                            <h5 class="fw-bold">Expert Advise</h5>
                            <p>Highly skilled professionals expert providing innovative and precise solutions for all your flooring needs.</p>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="feature-box text-left">
                            <img src="/assets/img/Group2.png" alt="Quality Material" class="feature-icon" />
                            <h5 class="fw-bold">Quality Material</h5>
                            <p>We use top-grade materials to ensure durability, strength, and long-lasting performance in every product.</p>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="feature-box text-left">
                            <img src="/assets/img/Group3.png" alt="24/7 Support" class="feature-icon" />
                            <h5 class="fw-bold">Support</h5>
                            <p>Our dedicated team is available to assist you with seamless service and quick solutions.</p>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="feature-box text-left">
                            <img src="/assets/img/Group4.png" alt="Affordable Price" class="feature-icon" />
                            <h5 class="fw-bold">Affordable Price</h5>
                            <p>Get cost-effective product without compromising on quality, ensuring great value for your investment.</p>
                        </div>
                    </div>
                </div>
            </section>


            <section class="container floring_section">
                <div class="text-uppercase text-primary fw-bold small"><p>🔗 Explore Our Featured Flooring Styles</p></div>
                <h5 class="fw-semibold mt-2">Discover a curated selection of premium wooden flooring, crafted for beauty, durability, and timeless appeal.</h5>

                <div class="row mt-4">
                    <div class="col-md-6">
                        <div class="flooring-box large-box">
                            <img src="https://admin.leapatinternational.com/assets/images/product/blog_20250221_27976.jpg" style={{ height: "519px" }} alt="Resistant to Scratches" />
                            <div class="overlay-text">
                                <Link
                                    to={`/category/5`}

                                >
                                    Eco Crafted Elegance Series
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 d-flex flex-column">


                        <div class="flooring-box">
                            <img src="https://admin.leapatinternational.com/assets/images/product/blog_20250222_87871.jpg" style={{ height: "250px" }} alt="Luxicore Legacy Series" />
                            <div class="overlay-text"> <Link
                                to={`/category/6`}

                            >
                                Luxicore Legacy Series
                            </Link></div>
                        </div>

                        <div class="flooring-box mt-3">
                            <img src="https://admin.leapatinternational.com/assets/images/product/blog_20250218_42886.jpg" style={{ height: "250px" }} alt="Waterproof" />
                            <div class="overlay-text">  <Link
                                to={`/category/7`}

                            >
                                Viva Wood Series
                            </Link></div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
